// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderInfo":"c-m_fx"};